import React, { useState } from "react";
import DateTimePicker from "@mui/lab/DateTimePicker";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import FormControl from "@mui/material/FormControl";

const DateFilter = (props) => {

    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleFilterChange = (e) => {
        const target = {target: {name: props.name, value: e}};
        console.log(e);
        setSelectedDate(target.target.value);
        props.onChange(target);
      };
  return (
    <FormControl sx={{ margin: 1.3 }}>
      {" "}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          renderInput={(p) => <TextField {...p} />}
          label={props.label}
          value={selectedDate}
          name={props.name}
          onChange={(e) => handleFilterChange(e)}
          disabled
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default DateFilter;
